import React, {Component} from "react"
import {NavLink} from "react-router-dom"
import {Disc, X, Circle} from "react-feather"
import classnames from "classnames"

class SidebarHeader extends Component {
  render() {
    let {
      toggleSidebarMenu,
      activeTheme,
      collapsed,
      toggle,
      sidebarVisibility,
      menuShadow
    } = this.props
    const {toggleSidebar, showSidebar} = this.props
    return (
      <div style={{height:'60.5px'}}className="navbar-header">
        <div className="sidebar-title">MENU</div>
        <div className="header_divider_mobile"></div>
        <ul className="nav navbar-nav">
          <li className="nav-item mr-auto">
          </li>
            <button className="btn side-btn" onClick={toggleSidebar}>
              <span>
              <svg className="menu-icon"><use href="/img/menu.svg#icon-menu_icon_mobile"/></svg>
              </span>
            </button>
        </ul>
        <div
          className={classnames("shadow-bottom", {
            "d-none": menuShadow === false
          })}
        />
      </div>
    )
  }
}

export default SidebarHeader
